<script setup lang="ts">
import { useUiStore } from "@/stores/ui.ts";
import { storeToRefs } from "pinia";
import { ThemeOverlay } from "@/ui-components";

const uiStore = useUiStore();
const { isOverlay } = storeToRefs(uiStore);
</script>

<template>
  <ThemeOverlay :active="isOverlay[0]" :priority="isOverlay[1]" />
  <ScreenReaderMessageContainer />
</template>
